import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const gettingStartedGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const isCompleted = localStorage.getItem('barterbridge_getting_started_completed') === 'true';
  const isManual = route.queryParamMap.get('manual') === 'true';

  if (isCompleted && !isManual) {
    // If completed and NOT manual, don't allow access to the getting-started slider
    // Redirect to home
    router.navigate(['/home']);
    return false;
  }

  return true;
};
